import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

//MUI
import { Box, Divider, Stack, Button, Checkbox, } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import DownloadIcon from '@mui/icons-material/Download';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//API
import { fnExcel, fni18n } from "../../services/commonService";
import { API } from "../../config";
import AuthenticationService from "../../pages/auth/AuthenticationService";
import { getAPI, postAPI, putAPI, deleteAPI,  } from "../../services/commonService";

// custom UI
import UTable from "../../components/mui/UTable";
import UDataGrid from "../../components/mui/UDataGrid";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UTextField from "../../components/mui/UTextField";
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UPagination from "../../components/mui/UPagination";
import MenuDetailPage from "../system/MenuDetailPage";
import MenuForm from "./MenuForm";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import USnackbar from "../../components/mui/USnackbar";
import UAuthFabAdd from "../../components/mui/UAuthFabAdd";
import USelectBox from "../../components/mui/USelectBox";
import { theme } from '../../assets/themes';
import UPopupForm from "../../components/mui/UPopupForm";

const useYn = [{cd:'Y', name:'Y', selected:true}, {cd:'N', name:'N'}, ];

const MenuManagementPage = () => {
	const { t } = useTranslation();
  // const [userName, setUserName] = useState('');
  
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const [menuList, setMenuList] = useState([]); //메뉴 리스트
    const [rowSelected, setRowSelected] = useState({}); // row선택 시 담아두기
    const [menuDetailInfo, setMenuDetailInfo] = useState({ //메뉴 정보
        pmenuNo : "",
        menuNo : "new",
        menuUrl : "/",
        menuNm : "",
        menuSeqNo : "1",
        visblYn : "Y",
        regisEmpNo : userLoginId,
    });
    const [loading, setLoading] = useState(false);
    const [searchVal, setSearchVal] = useState({
        menuNo : "",
        menuNm : "",
        useYn : "Y",
    });
    
    const [ formOpen, setFormOpen ] = useState(false); // modify dialog
    const [ confirmPopupOpen, setConfirmPopupOpen ] = useState(false); // confirm dialog
    const [ errorPopupOpen, setErrorPopupOpen ] = useState(false); // error dialog
    const [ showError, setShowError ] = useState(false);
    const [ errorMsg, setErrorMsg ] = useState(""); // api error message
    const [ snackOpen, setSnackOpen ] = useState(false);
    const [ snackSeverity, ] = useState('success');
    const [ snackMessage, setSnackMessage ] = useState('');
    
    const location = useLocation();
    
    const [ columnVisibilityModel, ] = useState({
      grpCd: false,
      grpNm: false,
      useAuth: false,
      regisEmpNo: false,
    }); // hidden colum

    /**
     * 화면 로드 시
     */
    useEffect(() => {
        const getLoadData = () => {
          try {
            //**TO DO 로그인 정보 저장 */
            // if (isUserId) {
            //   ApiComnService.GetLoggedInUserName(isUserId)
            //     .then((res) => {
            //       setIsUserName(res.data.EMP_NM);
            //     })
            //     .catch((err) => {
            //       console.log("API connect fail !", err);
            //     });
            // }
            handleSearch();
          } catch (e) {
            console.log(e);
          }
        };
        getLoadData();
      }, []);

    // 입력 데이타 유효성 검사
    const errors = useMemo(() => {
      const errors = {};
      if ( !menuDetailInfo.menuNm ) {
        errors.menuNm = fni18n('필수 입력 항목입니다')//'메뉴명은 필수 입력 항목입니다.'
      }
      // if ( menuDetailInfo.menuNo === 'new' && !menuDetailInfo.pmenuNo ) {
      //   errors.pmenuNo = fni18n('필수 입력 항목입니다')//'상위 메뉴명은 필수 입력 항목입니다.'
      // }
      if ( menuDetailInfo.menuNm && menuDetailInfo.menuNm.length > 25 ) {
        errors.menuNm = fni18n('최대 길이가 25입니다')//'메뉴명은 최대 길이가 25입니다.'
      }
      return errors;
    }, [menuDetailInfo])

    //DataGrid에서 row 선택 시 
    const onSelectedRow = (row) => {
      setRowSelected(row)
      setMenuDetailInfo(row)
      handleFormOpen()
    };
    // 상세 정보 변경 시 setter
    const onDetailChange = (e) => {
        const { name, value } = e.target;
        setRowSelected({
            ...rowSelected,
            [name] : value,
        });
        setMenuDetailInfo({
            ...menuDetailInfo,
            [name] : value,
        });
    };
    // YN 변경 시 setter
    const onSwitchChange = (e) => {
        setMenuDetailInfo({
          ...menuDetailInfo,
          [e.target.name]: e.target.checked === true ? "Y" : "N",
        });
    };
    //검색 조건 변경시 setter
    const onSearchChange = (e) => {
      const { name, value } = e.target;
        setSearchVal({
          ...searchVal,
          [name]: value,
        })
    };
  // 조회함수
  const handleSearch = async () => {
    setMenuList([]);
    let data = {
      menuNo : searchVal.menuNo.trim(),
      menuNm : searchVal.menuNm.trim()
    };
    try {
      setLoading(true);
      await getAPI(API.SYSTEM.MENU, searchVal)
      .then((res) => {
        setMenuList(res.data.result);
      })
      .catch((err) =>{
        console.log("Search Error! ", err);
      });
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
   // 저장함수
  const handleSave = () => {
    if ( Object.keys(errors).length > 0 ) {
      // handleErrorOpen()
      setShowError(true)
      return;
    }
    try {
      if (menuDetailInfo.menuNo === "new") { // 신규 등록
        postAPI(API.SYSTEM.MENU, menuDetailInfo)
        .then((res) => {
          if (res.data.code === 200) {
            handleSearch();
            // snack bar success open
            setSnackMessage(res.data.message);
            handleSnackOpen();
            handleFormClose()
          } else {
            // setErrorMsg(res.data.message || "Processing failed.")//"처리가 실패하였습니다.")
            setErrorMsg(t("처리가 실패하였습니다"))
            handleErrorOpen()
          }
        })
        .catch((err) =>{
          console.log("등록 Error! ", err);
        });
      } else  { // 수정
        putAPI(API.SYSTEM.MENU, menuDetailInfo)
        .then((res) => {
          if (res.data.code === 200) {
            handleSearch();
            // snack bar success open
            setSnackMessage(res.data.message);
            handleSnackOpen();
            handleFormClose()
          } else {
            // setErrorMsg(res.data.message || "Processing failed.")
            setErrorMsg(t("처리가 실패하였습니다"))
            handleErrorOpen()
          }
        })
        .catch((err) =>{
          console.log("메뉴 수정 Error! ", err);
        });
      }
    } catch (e) {
      console.log("수정 Error! ", e);
    } finally {
    }   
  };
   // 삭제함수
  const handleDelete = () => {
    // if (Object.keys(errors).length > 0 || menuDetailInfo.visblYn === 'N') {
    //   return;
    // }
    try {
      deleteAPI(API.SYSTEM.MENU, {menuNo : menuDetailInfo.menuNo,})
      .then((res) => {
        if (res.data.code === 200) {
          // handleCancel();
          handleSearch();
          // snack bar success open
          setSnackMessage(res.data.message);
          handleSnackOpen();
          handleFormClose()
        } else {
          // setErrorMsg(res.data.message || "Processing failed.")
          setErrorMsg(t("처리가 실패하였습니다"))
          handleErrorOpen()
        }
      })
      .catch((err) =>{
        console.log("삭제 Error! ", err);
      });
    } catch (error) {
      console.log(error)
    } finally{
      handleConfirmClose()
    }
  };
  // 되돌리기 함수
  const handleCancel = () => {
    setRowSelected({})
    setMenuDetailInfo({
      pmenuNo: "",
      menuNo: "new",
      menuUrl: "/",
      menuNm: "",
      menuSeqNo: "1",
      visblYn: "Y",
      regisEmpNo: userLoginId,
    })
    setShowError(false)
  };
  //삭제 확인 팝업 
  const handleConfirmOpen = () => {
    // if ( Object.keys(errors).length > 0  || menuDetailInfo.visblYn === 'N') {
    //   return;
    // }
    setConfirmPopupOpen(true);
  };
  const handleConfirmClose = () => {
    setConfirmPopupOpen(false);
  };

  //오류팝업 
  const handleErrorOpen = () => {
    setErrorPopupOpen(true);
  };
  const handleErrorClose = () => {
    setErrorMsg("")
    setErrorPopupOpen(false);
  };

  //성공 스낵바 
  const handleSnackOpen = () => {
    setSnackOpen(true);
  };
  const handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };

  //신규등록
  const handleAddNew = () => {
    handleCancel()
    handleFormOpen()
  }

  //폼 팝업
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
    /**
   * main list column set
   */
  const columns = [
    {
      field: "id",
      headerName: "번호",
      width: 70,
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: "menuNo",
      headerName: "메뉴번호",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "menuNm",
      headerName: "메뉴명",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "menuNmLevel",
      headerName: "메뉴경로",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "menuUrl",
      headerName: "메뉴URL",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "pmenuNo",
      headerName: "상위메뉴",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "menuSeqNo",
      headerName: "메뉴순서",
      width: 70,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "visblYn",
      headerName: "사용여부",
      width: 70,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      }
    },
    {
      field: "regisEmpNm",
      headerName: "등록자",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "regisDt",
      headerName: "등록일자",
      width: 150,
      headerAlign: "center",
      align: "center",
      /*valueFormatter: (params) => {
        if (params.value == null) {
          return "";
        }
        const valueFormatted = params.value.replace(
          /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g,
          "$1-$2-$3"
        );
        return `${valueFormatted}`;
      },*/
    },
    {
      field: 'modify',
      headerName: '설정',
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
      (
        <UButton
        // onButtonClick={handleFormOpen}
        onButtonClick={()=>onSelectedRow(params.rows)}
        variant="outlined"
        menuFrom={location.pathname}
        >보기
        </UButton>
      ),
    },
  ];
  return(
    <div className="main-container">
      <div className="header">
        <Grid container>
          <Grid item xs={10}>
            {/* 상단메뉴명 */}
            <UBreadCrumbs
                title={"시스템관리"}
                subtitle={"메뉴관리"}
                />
          </Grid>
          <Grid item xs={2}>
            {/* 툴바 버튼 */}
            <Stack 
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-start"
              spacing={0.5}
            >
              {/* <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={handleAddNew}>추가</UAuthButton>
              <UButton icon="Search" onButtonClick={handleSearch}>조회</UButton> */}
            </Stack>
          </Grid>
        </Grid>
      </div>
        {/* <Divider/>  */}
        
        {/* 조회조건 */}
        <Box className="contents">
            <TableContainer className="table-container" component={Paper} elevation={0}>
            <Table className="table" size="small">
                <TableBody>
                <TableRow className="table-row-header">
                    <TableCell className="table-cell-title">{fni18n('메뉴번호')}</TableCell>
                    <TableCell className="table-cell">
                      <UTextField
                      name="menuNo"
                      onChange={onSearchChange} 
                      /> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('메뉴명')}</TableCell>
                    <TableCell className="table-cell">
                      <UTextField
                      name="menuNm"
                      onChange={onSearchChange} 
                      /> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                    <TableCell className="table-cell">
                      <USelectBox
                        id="useYn"
                        name="useYn"
                        items={useYn}
                        onItemChange={onSearchChange}
                        defaultValue={searchVal.useYn}
                      />
                    </TableCell>
                    <TableCell className="table-cell"></TableCell>
                    <TableCell className="table-cell"></TableCell>
                </TableRow>
                </TableBody>
            </Table>
            </TableContainer>
            <div className="search">
                <UButton icon="Search" onButtonClick={handleSearch}>조회</UButton>
            </div>
            {/* 조회 리스트 */}
            <div style={{  width: "100%", display: "grid" }}>
              {/* <UDataGrid  columns={columns} data={menuList} onSelectedRow={onSelectedRow} />  */}
              <UTable columns={columns} rows={menuList} rowPerPage={11}
              toolbarAdd={
                <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={handleAddNew}>추가</UAuthButton>
              }
              />
            </div>
        </Box> 
        {/* <Divider/> */}


        {/* 상세 처리 버튼 리스트 >> 팝업으로 변경*/}
        {/* 조회 리스트 선택 상세 >> 팝업으로 변경*/}
        {/* 
        <Box sx={{ p: 1 }}>
        <Grid container>
          <Grid item xs={9}>
          </Grid>
          <Grid item xs={3}>
          <Stack direction="row" spacing={2}>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Save"
                onButtonClick={handleSave}
                menuFrom={location.pathname}
              >
                저장
              </UAuthButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Delete"
                onButtonClick={handleConfirmOpen}
                menuFrom={location.pathname}
              >
                삭제
              </UAuthButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Cancel"
                onButtonClick={handleCancel}
                menuFrom={location.pathname}
              >
                취소
              </UAuthButton>
            </FormControl>
            </Stack>
          </Grid>
        </Grid>
        </Box>
        
        <MenuDetailPage 
        data={menuDetailInfo} 
        onChange={onDetailChange} 
        onSwitchChange={onSwitchChange}
        errors={errors}
        showError={showError}
        /> 
        */}

        {/* 삭제 확인 팝업  */}
        <UConfirmDialog
        message={'[' + menuDetailInfo.menuNo + ']' + menuDetailInfo.menuNm + ' Are you sure you want to delete?'}//메뉴를 삭제하시겠습니까?
        open={confirmPopupOpen}
        onClose={handleConfirmClose}
        onClickOk={handleDelete}
        />

        {/* 오류 확인 팝업  */}
        <UAlertDialog
        alerts={errors}
        message={errorMsg}
        open={errorPopupOpen}
        onClose={handleErrorClose}
        />

        {/* 성공 스낵바  */}
        {/* <USnackbar
        open={snackOpen}
        onClose={handleSnackClose}
        severity={snackSeverity}
        message={snackMessage}
        /> */}

        {/* 폼 팝업  */}
        {/* <MenuForm
        title={fni18n("메뉴관리")}
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleSave}
        onDelete={handleConfirmOpen}
        detailInfo={menuDetailInfo} 
        onDetailChange={onDetailChange} 
        onSwitchChange={onSwitchChange}
        errors={errors}
        showError={showError}
        /> */}
        <UPopupForm
          open={formOpen}
          onClose={handleFormClose}
          onSave={handleSave}
          title="메뉴 설정"
          type={"2"}
          content={
          <MenuDetailPage 
          data={menuDetailInfo} 
          onChange={onDetailChange} 
          onSwitchChange={onSwitchChange}
          errors={errors}
          showError={showError}
          />}
        /> 

        {/* 추가버튼 */}
        {/* <UAuthFabAdd menuFrom={location.pathname} onClick={handleAddNew} /> */}
    </div>
    );
}

export default MenuManagementPage;